import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  error: null,
  flowId: null,
  region: '',
  flowType: '',
  flowName: '',
  config: {},
  clientId: '',
  userId: '',
  fetchedAt: null,
};

const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlowData(state, action) {
      const { flowId, region, flowType, flowName, config, fetchedAt, clientId, userId } = action.payload || {};
      state.status = 'succeeded';
      state.error = null;
      state.flowId = flowId ?? state.flowId;
      state.region = region ?? state.region;
      state.flowType = flowType ?? state.flowType;
      state.flowName = flowName ?? state.flowName;
      state.config = config ?? state.config;
      state.clientId = clientId ?? state.clientId;
      state.userId = userId ?? state.userId;
      state.fetchedAt = fetchedAt ?? Date.now();
    },
    resetFlowState() {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { setFlowData, resetFlowState } = flowSlice.actions;

// Selectors
export const selectFlowState = (state) => state.flow;
export const selectFlowStatus = (state) => state.flow.status;
export const selectFlowError = (state) => state.flow.error;
export const selectFlowId = (state) => state.flow.flowId;
export const selectFlowConfig = (state) => state.flow.config;
export const selectFlowBranding = (state) => state.flow?.config?.branding;
export const selectFlowRegion = (state) => state.flow.region;
export const selectFlowType = (state) => state.flow.flowType;
export const selectFlowFavicon = (state) => state.flow?.config?.branding?.favicon;

export default flowSlice.reducer;


